import { OperationDetailsModel } from "fs-pb-vue2/models/operations/operationDetailsModel";
import { StatementItemModel } from "fs-pb-vue2/models/statement/statementItemModel";
import { CatalogData } from "fs-pb-vue2/data/catalogData";
import { DeclarationPropertyValueData } from "fs-pb-vue2/data/declarationPropertyValueData";
import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";

/**
 * Детальная информация по операции 
 */
export class OperationDetailsModelFS extends OperationDetailsModel {

  constructor(
    operationData: StatementItemModel,
    requestData: OperationRequestData | null = null,
    respondentData: CatalogData | null = null,
    details: DeclarationPropertyValueData[] = []
  ) {
    super(operationData, requestData, respondentData, details);
  }

  public get isDboOperation(): boolean {
    if (this.RequestData.operationId > 0)
      return true;
    return false;
  }
}
